// extracted by mini-css-extract-plugin
module.exports = {"accordionContent":"AccordionWithRichText_accordionContent__XPBtC"};